// Form styling shared by the customer-site forms (same values as the contact form and the login popup).
export const inputClass =
  'w-full rounded-none border border-brand-border/70 bg-surface px-4 py-3 text-[15px] text-brand-dark placeholder:text-brand-muted focus:border-brand-primary focus:outline-none disabled:cursor-not-allowed disabled:opacity-60';

export const labelClass = 'mb-2 block text-sm font-medium text-brand-dark';
